import { GeomConstants } from '../math/geometry/geomConstants';
// this class behaves like one dimensional bounding box
export class RealNumberSpan {
    constructor() {
        this.isEmpty = true;
    }
    AddValue(x) {
        if (this.isEmpty) {
            this.max = x;
            this.min = x;
            this.isEmpty = false;
        }
        else if (x < this.min) {
            this.min = x;
        }
        else if (x > this.max) {
            this.max = x;
        }
    }
    get length() {
        return this.max - this.min;
    }
    // 0  if value is close to zero;
    // 1  if value is strictly greater than zero;
    // -1 if value is strictly lower than zero;
    static sign(value) {
        return value > GeomConstants.distanceEpsilon ? 1 : value < -GeomConstants.distanceEpsilon ? -1 : 0;
    }
}
//# sourceMappingURL=RealNumberSpan.js.map